export const getReportsType = (state) => state.report?.type;
export const getReportsAreas = (state) => state.report?.area;
